import { useState, useEffect, useContext, useRef } from 'react'
import { useForm } from 'react-hook-form'
import Modal from 'react-modal'
import axios from 'axios'
import axio from 'axios'
import Swal from 'sweetalert2'
import Loading from '../Loading'
import { projectContext, loadingContext, unfolder, onImportExcelAsync, urlValue, openAlert, useTranslate } from '../../lib'
import { InputNesting, TextareaNesting } from '../common/Inputs/Input'
import '../../styles/styles.css'
// import '../../styles/newProjectModal.scss'
// import { customModal } from '../../styles/customModal'
import AWS from 'aws-sdk'
import { Tooltip, } from 'react-tooltip'
import 'react-tooltip/dist/react-tooltip.css'
import ButtonYesNo from '../common/ButtonYesNo'
import BoxInfo from '../common/BoxInfo'

import { SelectNesting } from '../common/Inputs/Select'
import { Alerts } from '../common/Alerts'
import { validatePrompt } from '../../lib/promptValidator';

import ExcelUploadButton from './ExcelUploadButton';
import { CustomChat } from '../CustomChat'

export default function ProjectViewGenAi({ isModalOpen, closeModal, onClose }) {
  const [loading, setLoading] = useContext(loadingContext)
  const [campaings, setCampaings] = useState([])
  const [voices, setVoices] = useState([])
  const [listLanguage, setListLanguage] = useState([])
  const [changeLanguage, setChangeLanguage] = useState('')
  const [questions, setQuestions] = useState([{ question: "", suggested: "" }, { question: "", suggested: "" }, { question: "", suggested: "" }])
  const [evaluation_questions, setEvaluation_questions] = useState([{ "question1": "" }, { "question2": "" }, { "question2": "" }])
  const [radomVoice, setRadomVoice] = useState(false)
  const [ProjectExcel, setProjectExcel] = useState([])
  const [loadingUpload, setLoadingUpload] = useState(false)
  const [subCampaings, setSubCampaings] = useState([])
  const [useDefaultSentiment, setUseDefaultSentiment] = useState(0);
  const [selectedProject, setSelectedProject] = useContext(projectContext)
  const [hold, setHold] = useState(true)
  const [nlp_configName, setNlp_configName] = useState("Upload");
  const [imageName, setImageName] = useState("Upload");
  const [image, setImage] = useState(null);
  const [nlp_config, setNlp_config] = useState(null);
  const [error, setError] = useState({ name: "" })
  const [channel, setChannel] = useState("voice")
  const [category, setCategory] = useState('inbound');
  const [alert, setAlert] = useState({ title: '', visible: false });
  const [transcription, setTranscription] = useState(0);
  const timeHoldRef = useRef();
  const timeHoldAmountRef = useRef();
  const language = useRef();
  const campaingRef = useRef()
  const subCampaingRef = useRef()
  const affectation_time_ref = useRef();
  const percentage_affectation_ref = useRef();
  const name_ref = useRef();
  const description_ref = useRef();
  const url_tp_simulation_ref = useRef();
  const industry_ref = useRef();
  const problem_ref = useRef();
  const solucion_ref = useRef();
  const campaign_ref = useRef();
  const subcampaing_ref = useRef();
  const voice_ref = useRef();
  const welcome_mesage_ref = useRef();
  const minimunCallDurations = useRef();
  const maximunCallDurations = useRef();
  const maxUserResponseTime = useRef();
  const bot_respose_time_ref = useRef();
  const contact_driver_role_ref = useRef();
  const contact_driver_task_ref = useRef();
  const contact_driver_context_ref = useRef();
  const contact_driver_rules_ref = useRef();
  const contact_driver_forbidden_actions_ref = useRef();
  const contact_driver_default_fallback_ref = useRef();
  const contact_driver_example_ref = useRef();
  const contact_driver_other_ref = useRef();
  const Simulation_Step_number_ref = useRef();
  const minimum_passing_score_ref = useRef();
  const [simulationStatus, setSimulationStatus] = useState(0);
  const [assistedSimulation, setAssistedSimulation] = useState(0);
  const [azureScenario, setAzureScenario] = useState(0);
  const [customChats, setCustomChats] = useState([
    { id: 0, name: 'Standard' },
    { id: 1, name: 'WhatsApp' },
    { id: 2, name: 'Telegram' },
  ]);
  const [selectedChatOption, setSelectedChatOption] = useState(0);
  const [showCustomChatForm, setShowCustomChatForm] = useState(false);
  const [contactDriverForm, setContactDriverForm] = useState(false);
  const { t } = useTranslate();
  const fileString = ''
  // const {
  //   register,
  //   handleSubmit,
  //   formState: { errors },
  // } = useForm()

  const fetchCampaing = async () => {
    let token = unfolder(localStorage.getItem('hashUser'), 'IANestingKey').token
    let id = unfolder(localStorage.getItem('hashInfo'), 'IANestingKey').id

    try {
      const url = `${urlValue}/studio/project/camp/campaing`;
      const rest = await axio.get(url, {
        headers: {
          user: id,
          'access-token': token,
          'Content-Type': 'application/json',
        },
      });

      if (rest.status === 200 && rest.data) {
        setCampaings(rest.data.data)
      }
    } catch (error) {
      console.log(error)
    }
  }

  const fetchVoice = async () => {
    let token = unfolder(localStorage.getItem('hashUser'), 'IANestingKey').token
    let id = unfolder(localStorage.getItem('hashInfo'), 'IANestingKey').id
    const project_id = selectedProject.id;

    // setLoading(true)
    try {
      const url = `${urlValue}/studio/project/voices/all`;
      const rest = await axio.get(url, {
        headers: {
          user: id,
          'access-token': token,
          'Content-Type': 'application/json',
          language: language?.current?.value.substring(0, 2) || 'EN',
          'project_id': 0
        },
      });

      if (rest.status === 200 && rest.data) {
        setVoices(rest.data.data)
      }
    } catch (error) {
      console.log(error)
    }
  }

  const fetchLanguage = async () => {
    let token = unfolder(localStorage.getItem('hashUser'), 'IANestingKey').token
    let id = unfolder(localStorage.getItem('hashInfo'), 'IANestingKey').id
    // setLoading(true)
    try {
      const url = `${urlValue}/studio/language`;
      const rest = await axio.get(url, {
        headers: {
          'access-token': token,
          'Content-Type': 'application/json',
        },
      });

      if (rest.status === 200 && rest.data) {
        setListLanguage(rest.data.data)
      }
    } catch (error) {
      console.log(error)
    }
  }

  const fetchSubCampaing = async () => {
    let token = unfolder(localStorage.getItem('hashUser'), 'IANestingKey').token
    let id = unfolder(localStorage.getItem('hashInfo'), 'IANestingKey').id

    try {
      const url = `${urlValue}/studio/project/camp/sub-campaing`;
      const rest = await axio.get(url, {
        headers: {
          user: id,
          'access-token': token,
          'Content-Type': 'application/json',
        },
      });

      if (rest.status === 200 && rest.data) {
        setSubCampaings(rest.data.data)
      }
    } catch (error) {
      console.log(error)
    }
  }

  const fetchCustomChats = async () => {
    const predefined = [
      { id: 0, name: 'Standard' },
      { id: 1, name: 'WhatsApp' },
      { id: 2, name: 'Telegram' },
    ];
    
    let token = unfolder(localStorage.getItem('hashUser'), 'IANestingKey').token
    let id = unfolder(localStorage.getItem('hashInfo'), 'IANestingKey').id;
    
    try {
      const url = `${urlValue}/studio/project/customchats/all`;
      
      const rest = await axios.get(url, {
        headers: {
          user: id,
          'access-token': token,
          'Content-Type': 'application/json',
          'project_id': 0
        },
      });
  
      if (rest.status === 200 && rest.data.data) {
        setCustomChats([...predefined, ...rest.data.data])
      }
      return rest.data.data;
    } catch (error) {
      setCustomChats(predefined)
      console.log(error)
      return error;
    }
  };

  useEffect(() => {
    fetchCampaing();
    fetchSubCampaing();
    fetchLanguage();
    fetchVoice();
    fetchCustomChats();
  }, [])

  const onChangeStatusSimulation = () => {
    setSimulationStatus((prev) => prev === 0 ? 1 : 0);
    if (simulationStatus === 1) {
      setAssistedSimulation(0);
    }
  }

  const convertToBase64 = (file) => {
    return new Promise(resolve => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        resolve(reader.result);
      }
    })
  }

  const containsEmoji = (str) => {
    if (!str) return false;

    try {
      // Usa Unicode property escapes (mejor soporte en navegadores modernos)
      const re = /(\p{Emoji_Presentation}|\p{Extended_Pictographic})/u;
      return re.test(str);
    } catch (e) {
      // Fallback para navegadores antiguos
      const fallback = /[\uD800-\uDBFF][\uDC00-\uDFFF]/;
      return fallback.test(str);
    }
  };

  const createProject = async () => {
    let ok = true
    let token = unfolder(localStorage.getItem('hashUser'), 'IANestingKey').token
    let csrfToken = unfolder(localStorage.getItem('hashUser'), 'IANestingKey').csrfToken

    let convertedFile = ""
    if (image) {
      convertedFile = await convertToBase64(image)
    }


    const exp = /^[A-Za-z0-9-,._'¿?\s]+$/g;
    if (!exp.test(name_ref.current?.value)) {
      ok = false;
      setError({ ...error, name: t('errors.nameInvalid') })
    }

    const minCallTime = Number(minimunCallDurations.current?.value || 0);
    const maxCallTime = Number(maximunCallDurations.current?.value || 0);
    if (minCallTime > maxCallTime) {
      ok = false;
      openAlert(
        '#alert-ac',
        () => setAlert({ title: t('alerts.valideMaxAndMinCall'), visible: true, error: true }),
        4000,
        () => setAlert({ ...alert, visible: false })
      );
    }

    const emojiRole = containsEmoji(contact_driver_role_ref?.current?.value)
    const emojiTask = containsEmoji(contact_driver_task_ref?.current?.value)
    const emojiContext = containsEmoji(contact_driver_context_ref?.current?.value)
    const emojiRules = containsEmoji(contact_driver_rules_ref?.current?.value)
    const emojiForbidden = containsEmoji(contact_driver_forbidden_actions_ref?.current?.value)
    const emojiDefault = containsEmoji(contact_driver_default_fallback_ref?.current?.value)
    const emojiExample = containsEmoji(contact_driver_example_ref?.current?.value)
    const emojiOther = containsEmoji(contact_driver_other_ref?.current?.value)

    if (emojiRole || emojiTask || emojiContext || emojiRules || emojiForbidden || emojiForbidden || emojiDefault 
      || emojiExample || emojiOther) 
    {
      ok = false;
      openAlert(
        '#alert-ac',
        () => setAlert({ title: t('alerts.validateEmoji'), visible: true, error: true }),
        4000,
        () => setAlert({ ...alert, visible: false })
      );
    }

    if (ok) {
      const dataSend = {
        name: name_ref.current?.value,
        //Se cambio a null temporalmente hasta la primera entrega despues agregar id de cada nlp Dlowflow RASA
        nlp: 1,
        nlp_config: {},
        nlp_url: 'localhost',
        metadata: { "description": description_ref.current?.value, "language": language.current.value },
        //Se cambio a null temporalmente hasta la primera entrega despues /agregar la imagen
        image: { "imageName": imageName, "url": "" } || null,
        imageFile: convertedFile || null,
        time_hold_amount: timeHoldAmountRef.current?.value || 0,
        time_hold_seconds: timeHoldRef.current?.value || 0,
        use_hold: hold ? 1 : 0,
        campaing: campaign_ref.current?.value,
        sub_campaing: subcampaing_ref.current?.value,
        voice: voice_ref.current?.value || 0,
        random_voice: radomVoice ? 1 : 0,
        type: "GEN AI",
        channel: channel,
        transcription: 0,
        contact_driver_role: contact_driver_role_ref?.current?.value,
        contact_driver_task: contact_driver_task_ref?.current?.value,
        contact_driver_context: contact_driver_context_ref?.current?.value,
        contact_driver_rules: contact_driver_rules_ref.current.value,
        contact_driver_forbidden_actions: contact_driver_forbidden_actions_ref?.current?.value,
        contact_driver_default_fallback: contact_driver_default_fallback_ref?.current?.value,
        contact_driver_example: contact_driver_example_ref?.current?.value,
        contact_driver_other: contact_driver_other_ref?.current?.value,
        evaluation_questions: questions,
        url_tp_simulation: url_tp_simulation_ref.current.value,
        simulation_status: simulationStatus,
        num_simulation_steps: Simulation_Step_number_ref.current?.value || 0,
        assisted_simulation: assistedSimulation,
        azure_scenario: azureScenario,
        custom_chat: selectedChatOption,
        minimum_passing_score: minimum_passing_score_ref.current?.value || 70,
        category: category,
        outbound_call: category === 'outbound' ? 1 : 0,
        welcome_msg: welcome_mesage_ref?.current?.value,
        min_call_time: minimunCallDurations.current?.value || 0,
        max_call_time: maximunCallDurations.current?.value || 0,
        max_user_response_time: maxUserResponseTime.current?.value || 0,
        bot_response_time: bot_respose_time_ref?.current?.value || 0,

      }

      let id = unfolder(localStorage.getItem('hashInfo'), 'IANestingKey').id

      axios({
        method: 'post',
        url: `${urlValue}/studio/project`,
        headers: {
          user: id,
          'access-token': token,
          'X-CSRF-Token': csrfToken

        },
        withCredentials: true,
        data: dataSend,
        // data: formDataImage
      })
        .then(function (response) {
          openAlert('#alert-ac', () => { setAlert({ title: t('alerts.projectSaved'), visible: true, error: false }) }, 4000, () => { setAlert({ ...alert, visible: false }) });
          onClose();
          setLoading(false)
          window.location.reload();
        })
        .catch(function (error) {
          let message = t('alerts.projectNotSaved')
          if (error.response.status == 401) {
            message = error.response.data.message
          }
          openAlert('#alert-ac', () => { setAlert({ title: message, visible: true, error: true }) }, 4000, () => { setAlert({ ...alert, visible: false }) });
          console.log(error)
          // onClose()
          setLoading(false)
        })
    }
  }

  const uploadMaxive = async () => {

    if (!loadingUpload && ProjectExcel.length > 0 && ProjectExcel.length <= 51) {

      setLoadingUpload(true)
      setTimeout(async () => {

        let id = unfolder(localStorage.getItem('hashInfo'), 'IANestingKey').id;
        let token = unfolder(localStorage.getItem('hashUser'), 'IANestingKey').token
        let csrfToken = unfolder(localStorage.getItem('hashUser'), 'IANestingKey').csrfToken
        for (var i = 0; i < ProjectExcel.length; i++) {
          const dataSend = {
            name: ProjectExcel[i].Name?.trim(),
            //Se cambio a null temporalmente hasta la primera entrega despues agregar id de cada nlp Dlowflow RASA
            nlp: 1,
            nlp_config: JSON.parse(ProjectExcel[i].Motor_Congnitivo),
            nlp_url: 'localhost',
            metadata: { "description": ProjectExcel[i].Description, "language": ProjectExcel[i].Language },
            //Se cambio a null temporalmente hasta la primera entrega despues /agregar la imagen
            image: null,
            time_hold_amount: ProjectExcel[i].Hold_Attempts_per_call || 0,
            time_hold_seconds: ProjectExcel[i].Hold_Time_Seconds || 0,
            use_hold: ProjectExcel[i].Use_hold_time === 1 ? 1 : 0,
            campaing: ProjectExcel[i].Campaign,
            sub_campaing: ProjectExcel[i].SubCampaign

          }

          const rest = await axios.post(`${urlValue}/studio/project`, dataSend, {
            headers: {
              user: id,
              'access-token': token,
              'X-CSRF-Token': csrfToken
            },
            withCredentials: true
          })
        }
        setLoadingUpload(false);
        window.location.reload();
      }, 1000)

    } else {
      alert(t('alerts.projectExcelLimit'))
    }

  }
  const prepareExcel = async (e) => {
    const DatosExcel = await onImportExcelAsync(e);
    setProjectExcel(DatosExcel)
  }

  const ChangeModelSentiment = (e) => {
    if (e.target.value === 'Voice') {
      console.log("change");
      selectedProject.bot_sentiment = 0;
    }
  }

  const saveBotSentimentConfig = function (e) {

    let id = unfolder(localStorage.getItem('hashInfo'), 'IANestingKey').id
    let token = unfolder(localStorage.getItem('hashUser'), 'IANestingKey').token
    let csrfToken = unfolder(localStorage.getItem('hashUser'), 'IANestingKey').csrfToken

    axios({
      method: 'post',
      url: `${urlValue}/studio/project/${selectedProject.id}/bot_sentiment`,
      headers: {
        user: id,
        'access-token': token,
        'X-CSRF-Token': csrfToken
      },
      withCredentials: true,
      data: {
        bot_sentiment: e.target.value,
      }
    }).then(function (res) {
      // console.log('res');
    }).catch(error => {
      console.log('Error to try update bot sentiment: ', error);
    })
  }

  const industries = [
    { id: 1, name: "BFSI" },
    { id: 2, name: "Gaming" },
    { id: 3, name: "News & Media" },
    { id: 4, name: "Tech App Food & Delivery" },
    { id: 5, name: "Tech-Home Services" },
    { id: 6, name: "Telecom" },
    { id: 7, name: "Travel & Hospitality" },
    { id: 8, name: "Other" },
  ]

  const onChangeQuestion = (e, index) => {
    const q = [...questions];
    q[index].question = e.target.value
    setQuestions(q)
  }

  const onChangeSuggested = (e, index) => {
    const q = [...questions];
    q[index].suggested = e.target.value
    setQuestions(q)
  }

  const addQuestiong = () => {
    setQuestions((prev) => [...prev, { question: "", suggested: "" }])
  }
  const deleteQuestiong = (index) => {
    setQuestions((prev) => prev.filter((x, i) => i !== index))
  }

  /* Add Default Prompt from Environment Variable */
  const addPromptDefault = () => {

    const DEFAULT_PROMPT = process.env.REACT_APP_PROMPT_START;

    if (contact_driver_context_ref.current) {
      contact_driver_context_ref.current.value = DEFAULT_PROMPT;
    }

  }

  const addPromptDefaultFromServer = async () => {

    if (contact_driver_role_ref.current.value !== '' || contact_driver_task_ref.current.value !== ''
      || contact_driver_context_ref.current.value !== '' || contact_driver_rules_ref.current.value !== ''
      || contact_driver_forbidden_actions_ref !== '' || contact_driver_default_fallback_ref.current.value !== ''
      || contact_driver_example_ref.current.value !== '' || contact_driver_other_ref.current.value !== ''
    ) {
      const result = await Swal.fire({
        title: t('menu.confirmation'),
        text: t('alerts.updatePrompt'),
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: t('common.yes'),
        cancelButtonText: t('common.no')
      });

      if (!result.isConfirmed) {
        return;
      }
    }

    let token = unfolder(localStorage.getItem('hashUser'), 'IANestingKey').token;
    let id = unfolder(localStorage.getItem('hashInfo'), 'IANestingKey').id;

    axios({
      method: 'get',
      url: `${urlValue}/studio/prompt/library/default`,
      headers: {
        user: id,
        'access-token': token,
      },
    })
      .then(function (response) {
        contact_driver_role_ref.current.value = response?.data?.role;
        contact_driver_task_ref.current.value = response?.data?.task;
        contact_driver_context_ref.current.value = response?.data?.context;
        contact_driver_rules_ref.current.value = response.data?.rules;
        contact_driver_forbidden_actions_ref.current.value = response.data?.forbidden_actions;
        contact_driver_default_fallback_ref.current.value = response.data?.default_fallback;
        contact_driver_example_ref.current.value = response.data?.example;
        contact_driver_other_ref.current.value = response.data?.other;
      })
      .catch(function (error) {
        openAlert('#alert-ac', () => { setAlert({ title: t('alerts.failedTemplate'), visible: true, error: true }) }, 4000, () => { setAlert({ ...alert, visible: false }) });
        console.error(error)
        // onClose()
        setLoading(false)
      });
  }

  const showContactDriverForm = async (show) => {
    setContactDriverForm(show);
    //await getProject();
  }

  const verifyPrompt = () => {
    const refs = {
      contact_driver_role_ref,
      contact_driver_task_ref,
      contact_driver_context_ref,
      contact_driver_rules_ref,
      contact_driver_forbidden_actions_ref,
      contact_driver_default_fallback_ref,
      contact_driver_example_ref
    };

    return validatePrompt(refs, t);
  };

  return (

    <div className="newProject-modal modal-cont ">
      <h1>{t('menu.createProject')} </h1>
      <form className="w-100">
        <div className="scroll-gen-modal sm7-h-50vh sm6-h-50vh sm5-h-70vh sm4-h-70vh sm3-h-70vh h-80 " >


          <div className='flex w-full' >
            <div className='flex  flex-col flex-1'>
              <InputNesting
                ref={name_ref}
                id="name"
                title={t('common.name')}
                tooltip={true}
                tooltipText={t('alerts.charactersNameTooltip')}
                placeholder={t('menu.genai.typeNewProject')}
              />

              <TextareaNesting
                ref={description_ref} id="description"
                title={t('common.description')} row={3}
                containerClass="mt-2"
                placeholder={t('menu.genai.detailedDescriptionPlaceholder')}
              />
            </div>

            <div className="inputs flex-1 ml-3" style={{  paddingRight: 15 }} id="image">
              <div className="input">
                <div className="flex items-center">
                  <span>{t('menu.genai.projectLogo')}</span>
                  <img id="image-tp" src="/icons/tooltip-indicator-icon.svg" className="ml-1 cursor-pointer tooltip-nesting  " alt="" />
                  <Tooltip openOnClick={true} anchorSelect="#image-tp" content={t('menu.genai.projectLogoTooltip')} place="top" />
                </div>
                <label className="custom-file">
                  <input
                    onChange={(e) => { setImage(e.target.files[0]); setImageName(e.target.files[0].name) }}
                    // onChange={e => fileUploadHandler(e)}
                    type="file"
                    accept="image/png, .jpeg, .jpg"
                  />
                  {imageName}
                </label>

                <div>
                  {image && <img src={URL.createObjectURL(image)} alt='' style={{ width: "100%", height: 120, objectFit: "contain" }} />}
                </div>
              </div>
            </div>
          </div>
          <div className='separator-n mt-2 mb-1 mr-1' />
          <div className=" flex  justify-space-between  "  >
            <div className="d-flex flex-column flex-1" style={{ paddingRight: 20, }} >

              <div className="d-flex flex-column pl-2" style={{ width: '100%', paddingRight: 15 }}>
                <div className='mt-4 d-flex flex-row flex-wrap align-items-center justify-content-between w-100'>
                  <div className='d-flex flex-row align-items-center'>
                    <h2 className="m-0" style={{ color: '#0B5FA3', fontSize: 18, minWidth: 130 }}>
                      {t('menu.genai.contactDriver')}
                    </h2>

                    <button id='arrow-down-btn' style={{ display: !contactDriverForm ? 'block' : 'none' }}
                      className='ml-3' type='button' onClick={() => showContactDriverForm(true)}>
                      <img src='/icons/arrow_down.png' style={{ width: 20 }} alt='' />
                    </button>

                    <button id='arrow-down-btn' style={{ display: contactDriverForm ? 'block' : 'none' }}
                      className='ml-3' type='button' onClick={() => showContactDriverForm(false)}>
                      <img src='/icons/arrow_up.png' style={{ width: 20 }} alt='' />
                    </button>
                  </div>

                  <div className="flex-row align-items-center w-100 mt-3" 
                    style={{ marginRight: 20, display: contactDriverForm ? 'flex' : 'none', justifyContent: 'space-between', minWidth: 302 }}>
                    <button className='btn-add' type='button' onClick={verifyPrompt}>
                      <img src='/icons/verify_prompt.png' style={{ width: 22 }} alt='' />
                      <span className='ml-5'>{t('menu.genai.verifyPrompt')}</span>
                    </button>
                    <button className='btn-add' type='button' onClick={addPromptDefaultFromServer}>
                      <img src='/icons/add-icon-nt.png' style={{ width: 22 }} alt='' />
                      <span className='ml-5'>{t('menu.genai.addPromptTemplate')}</span>
                    </button>
                  </div>

                </div>
                <div style={{ display: contactDriverForm ? 'flex' : 'none' }}
                  className="flex-row flex-wrap">

                  <div className='d-flex flex-column' style={{ flexGrow: '1' }}>
                    <div className='mt-4 d-flex flex-row align-items-center justify-content-between'>
                      <label htmlFor="contact_driver_role" style={{ margin: 0, fontSize: 14, color: "#2E2E2E", fontWeight: '700' }}>{t('menu.genai.role')}:</label>
                    </div>
                    <div className='flex items-center'>
                      <TextareaNesting
                        row={4}
                        ref={contact_driver_role_ref} id="contact_driver_role"
                        title="" containerClass="flex-1 mr-2 mt-0"
                      />
                    </div>

                    <div className='mt-4 d-flex flex-row align-items-center justify-content-between'>
                      <label htmlFor="contact_driver_task" style={{ margin: 0, fontSize: 14, color: "#2E2E2E", fontWeight: '700' }}>{t('menu.genai.task')}:</label>
                    </div>
                    <div className='flex items-center'>
                      <TextareaNesting
                        row={4}
                        ref={contact_driver_task_ref} id="contact_driver_task"
                        title="" containerClass="flex-1 mr-2 mt-0 "
                      />

                    </div>
                  </div>

                  <div className='d-flex flex-column mt-2 ml-3' style={{ flexGrow: '2' }}>
                    <div className='d-flex flex-row align-items-center justify-content-between'>
                      <label htmlFor="contact_driver_context" style={{ margin: 0, fontSize: 14, color: "#2E2E2E", fontWeight: '700' }}>{t('menu.genai.context')}:</label>
                    </div>
                    <div className='flex items-center'>
                      <TextareaNesting
                        row={11}
                        ref={contact_driver_context_ref} id="contact_driver_context"
                        title="" containerClass="flex-1 mr-2 mt-0 "
                      />
                    </div>
                  </div>

                  <div className='d-flex flex-column w-100' style={{ flexGrow: '1' }}>
                    <div className='mt-4 d-flex flex-row align-items-center justify-content-between'>
                      <label htmlFor="contact_driver_rules" style={{ margin: 0, fontSize: 14, color: "#2E2E2E", fontWeight: '700' }}>{t('menu.genai.rules')}:</label>
                    </div>
                    <div className='flex items-center'>
                      <TextareaNesting
                        row={4}
                        ref={contact_driver_rules_ref} id="contact_driver_rules"
                        title="" containerClass="flex-1 mr-2 mt-0"
                      />
                    </div>
                  </div>

                  <div className='d-flex flex-column w-100' style={{ flexGrow: '1' }}>
                    <div className='mt-4 d-flex flex-row align-items-center justify-content-between'>
                      <label htmlFor="contact_driver_forbidden_actions" style={{ margin: 0, fontSize: 14, color: "#2E2E2E", fontWeight: '700' }}>{t('menu.genai.forbiddenActions')}</label>
                    </div>
                    <div className='flex items-center'>
                      <TextareaNesting
                        row={4}
                        ref={contact_driver_forbidden_actions_ref} id="contact_driver_forbidden_actions"
                        title="" containerClass="flex-1 mr-2 mt-0"
                      />
                    </div>
                  </div>

                  <div className='d-flex flex-column w-100' style={{ flexGrow: '1' }}>
                    <div className='mt-4 d-flex flex-row align-items-center justify-content-between'>
                      <label htmlFor="contact_driver_default_fallback" style={{ margin: 0, fontSize: 14, color: "#2E2E2E", fontWeight: '700' }}>{t('menu.genai.defaultFallback')}:</label>
                    </div>
                    <div className='flex items-center'>
                      <TextareaNesting
                        row={4}
                        ref={contact_driver_default_fallback_ref} id="contact_driver_default_fallback"
                        title="" containerClass="flex-1 mr-2 mt-0"
                      />
                    </div>
                  </div>

                  <div className='d-flex flex-column w-100' style={{ flexGrow: '1' }}>
                    <div className='mt-4 d-flex flex-row align-items-center justify-content-between'>
                      <label htmlFor="contact_driver_example" style={{ margin: 0, fontSize: 14, color: "#2E2E2E", fontWeight: '700' }}>{t('menu.genai.example')}:</label>
                    </div>
                    <div className='flex items-center'>
                      <TextareaNesting
                        row={4}
                        ref={contact_driver_example_ref} id="contact_driver_example"
                        title="" containerClass="flex-1 mr-2 mt-0"
                      />
                    </div>
                  </div>

                  {/*<div className='d-flex flex-column w-100' style={{ flexGrow: '1' }}>
                    <div className='mt-4 d-flex flex-row align-items-center justify-content-between'>
                      <label htmlFor="contact_driver_other" style={{ margin: 0, fontSize: 14, color: "#2E2E2E", fontWeight: '700' }}>Other:</label>
                    </div>
                    <div className='flex items-center'>
                      <TextareaNesting
                        row={4}
                        ref={contact_driver_other_ref} id="contact_driver_other"
                        title="" containerClass="flex-1 mr-2 mt-0"
                      />
                    </div>
                  </div>*/}
                </div>
              </div>

              <div className='separator-n mt-5 mb-3' />
                <div>
                  <span className='mt-2 mb-1' style={{ marginBottom: 2, marginTop: 15, color: "#474746" }}>
                    {t('menu.genai.evaluationFormulary')}
                  </span>
                  <div className='mt-2'>
                    <ExcelUploadButton 
                      onQuestionsLoaded={(loadedQuestions) => {
                        setQuestions(loadedQuestions);
                      }}
                    />
                  </div>
                </div>    
              
              <div className='flex flex-col mt-3'>
                {questions?.map((item, index) => (
                  <div style={{display: 'flex', flexDirection: 'column', marginBottom: 30}}>
                    <InputNesting
                      containerClass="w-full"
                      defaultValue={item.question}
                      onChange={(e) => onChangeQuestion(e, index)}
                      title={`${t('common.question')} ${index + 1}:`}
                    />
                    <InputNesting
                      containerClass="w-full" style={{marginTop: 15}}
                      defaultValue={item?.suggested}
                      onChange={(e) => onChangeSuggested(e, index)}
                      title={`${t('menu.feedback')} ${index + 1}:`}
                    />
                    <button type='button' className='m-2 buttonH' 
                      style={{display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center', maxWidth: 150}}
                      onClick={() => deleteQuestiong(index)} >
                      <img src={'/icons/trash-1.png'} style={{marginRight: 10, width: 15}} />
                      {t('menu.genai.deleteQuestion')}
                    </button>

                  </div>
                ))}
                <button className='btn-add mt-2' type='button' onClick={addQuestiong}>
                  <img src='/icons/add-icon-nt.png' style={{ width: 22 }} alt='' />
                  <span className='ml-5'>{t('menu.genai.addQuestion')}</span>
                </button>
              </div>


            </div>

            <div className='mb-3 mt-2' style={{ borderRight: '1px solid #bfbfbf' }}></div>

            <div className=" flex flex-col flex-1 mt-2" style={{ paddingRight: 20, paddingLeft: 20 }}>

              <div className="inputs" style={{ marginTop: 25 }}>
                <div className="input d-flex flex-row align-items-center" style={{ alignItems: "center", flexDirection: "row" }}>
                  <div className="flex items-center">
                    <span>{t('menu.genai.botType')}:</span>
                    <img id="bottype-tp" src="/icons/tooltip-indicator-icon.svg" className="ml-5 cursor-pointer tooltip-nesting  " alt="" />
                    <Tooltip openOnClick={true} anchorSelect="#bottype-tp" content={t('menu.genai.inboundOuntboundTooltip')} place="top" />
                  </div>
                  <div className="ml-2 list_bot_type d-flex flex-row align-items-center" >
                    <ButtonYesNo
                      onClick={() => setChannel((prev) => prev === "voice" ? "chat" : "voice")}
                      width={170}
                      state={channel === "chat" ? false : true}
                      height={30}
                      Yes={t('menu.voiceBot')}
                      No={t('menu.chatBot')}
                    />
                  </div>
                </div>
              </div>

              <div className="inputs" style={{ marginTop: 20 }}>
                <div className="input" style={{maxWidth: 200}}>
                  <div className="d-flex flex-row align-items-center w-100">
                    <span>{t('common.language')}:</span>
                    <img id="language" src="/icons/tooltip-indicator-icon.svg" className="ml-2 cursor-pointer tooltip-nesting" alt="" />
                    <Tooltip openOnClick={true} anchorSelect="#language" textColor="#ffffff"
                        html={t('menu.genai.languageForProjectTooltip')} place="top" />
                    <select ref={language} id="language" onChange={(e) => { fetchVoice() }} className='select ml-3 select-nesting input-data ' 
                      style={{ flexGrow: '2' }}>
                        {listLanguage.map((item, index) => (<option key={index} value={item.value}>{item.name}</option>))}
                    </select>
                  </div>
                </div>
              </div>

              <div className="inputs" style={{ marginTop: 25 }}>
                <div className="input d-flex flex-row align-items-center" style={{ alignItems: "center", flexDirection: "row" }}>
                  <span>{t('menu.genai.interactionType')}:</span>
                  <div className="list_call_type ml-2 d-flex flex-row align-items-center">
                    <ButtonYesNo
                      onClick={() => setCategory((prev) => prev === "outbound" ? "inbound" : "outbound")}
                      width={170}
                      state={category === "outbound" ? false : true}
                      height={30}
                      Yes={t('common.inbound')}
                      No={t('common.outbound')}
                    />
                  </div>
                </div>
              </div>

              {category === 'outbound' && <TextareaNesting
                containerClass="mr-2 mt-3"
                ref={welcome_mesage_ref}
                id="welcome_mesage"
                type="text"
                row={4}
                title={`${t('menu.genai.outboundCallMessage')}:`}
                boxInfo={true}
                tooltipText={t('menu.genai.outboundCallMessageTooltip')}
              />}

              <div className="inputs" style={{ marginTop: 20 }}>
                <div className="input" id="selectbox">
                  <div className="d-flex flex-row align-items-center justify-space-between w-100">
                    <span>{t('common.campaign')}:</span>
                    <img id="campaign-tp" src="/icons/tooltip-indicator-icon.svg" className="ml-1 cursor-pointer tooltip-nesting" alt="" />
                    <Tooltip openOnClick={true} anchorSelect="#campaign-tp" html={t('menu.genai.campaignTooltip')} place="top" />
                    <select ref={campaign_ref} className='select ml-3 select-nesting input-data'
                      onChange={(e) => { }} style={{ flexGrow: '2', backgroundPositionX: "96%", height: "100%" }}>
                      <option disabled selected>
                        {t('menu.genai.campaignForProject')}
                      </option>
                      {campaings.map((item, i) => (
                        <option value={item.id} key={item.id}>{item.name}</option>
                      ))}
                    </select>
                  </div>
                </div>
              </div>


              <div className="inputs" style={{ marginTop: 20 }}>
                <div className="input" id="selectbox">
                  <div className="d-flex flex-row align-items-center justify-space-between w-100">
                    <span>{t('common.subCampaign')}:</span>
                    <img id="subcampaign-tp" src="/icons/tooltip-indicator-icon.svg" className="ml-1 cursor-pointer tooltip-nesting" alt="" />
                    <Tooltip openOnClick={true} anchorSelect="#subcampaign-tp" html={`Select the subcampaign for the project`} place="top" />
                    <select ref={subcampaing_ref} className='select ml-3 select-nesting input-data' 
                      style={{ flexGrow: '2', backgroundPositionX: "96%", height: "100%" }} 
                      onChange={(e) => { }}>
                      <option disabled selected>
                        {t('menu.genai.subcampaignForProject')}
                      </option>
                      {subCampaings.map((item, i) => (
                        <option value={item.id} key={item.id}>{item.name}</option>
                      ))}
                    </select>
                  </div>
                </div>
              </div>

              {channel === 'voice' &&
                <div className="input">
                  <div className='d-flex flex-row align-items-center mt-5  w-100'>
                    <div className="flex items-center mr-4" style={{ marginBottom: "2%" }}>
                      <span className='label-select' holdAttempts>{t('menu.genai.onHoldAvailability')}:</span>
                      <img id="hold-tp" src="/icons/tooltip-indicator-icon.svg" className="ml-3 cursor-pointer tooltip-nesting  " alt="" />
                      <Tooltip openOnClick={true} anchorSelect="#hold-tp" 
                        html={t('menu.genai.onHoldAvailabilityTooltip')} place="top" />
                    </div>
                    <ButtonYesNo
                      onClick={() => setHold((prev) => !prev)}
                      width={140} zIndex='0'
                      state={hold}
                      height={30}
                    />
                  </div>
                </div>
              }

              <div className=" flex flex-row items-center mt-2">
                {channel === 'voice' &&
                  <div className="inputs ml-2">
                    <div className="input">
                      <div className='d-flex flex-column w-100'>
                        <div className='d-flex flex-row align-items-center' style={{ marginRight: 50 }}>
                          <span style={{fontSize: 14}}>{t('menu.genai.holdAttempts')}:</span>
                          <img id="hold-attempts-tp" src="/icons/tooltip-indicator-icon.svg" className="ml-2 cursor-pointer tooltip-nesting" alt="" />
                          <Tooltip openOnClick={true} anchorSelect="#hold-attempts-tp" 
                            html={t('menu.genai.holdAttemptsTooltip')} place="top" />
                        </div>
                        
                        <div className="d-flex flex-row align-items-center mt-2">
                          <input style={{ maxWidth: 113 }}
                            ref={timeHoldAmountRef}
                            className='mt-3 input-data'
                            disabled={!hold}
                            type="number"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                }
                
                {channel === 'voice' &&
                  <div className="inputs">
                    <div className="input">
                      <div className='d-flex flex-column'>
                        <div className='d-flex flex-row align-items-center'>
                          <span style={{fontSize: 14}}>{t('menu.genai.holdTime')}:</span>
                          <img id="hold-time-tp" src="/icons/tooltip-indicator-icon.svg" className="ml-1 cursor-pointer tooltip-nesting" alt="" />
                          <Tooltip openOnClick={true} anchorSelect="#hold-time-tp" className='ml-3'
                            html={t('menu.genai.holdTimeTooltip')} place="top" />
                        </div>
                        <div className="d-flex flex-row align-items-center mt-2">
                          <input style={{ maxWidth: 113 }}
                            ref={timeHoldRef}
                            className='mt-3 input-data'
                            disabled={!hold}
                            type="number"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                }
              </div>

              <div className=" flex flex-row items-center mt-3">
                {channel === 'voice' &&
                  <div className="inputs">
                    <div className="input">
                      <div className='d-flex flex-row align-items-center'>
                        <span>{t('menu.genai.minimunCallDurations')}:</span>
                        <img id="min-call-duration-tp" src="/icons/tooltip-indicator-icon.svg" className="ml-1 cursor-pointer tooltip-nesting" alt="" />
                        <Tooltip openOnClick={true} anchorSelect="#min-call-duration-tp" 
                          html={t('menu.genai.minimunCallDurationsTooltip')} place="top" />
                        <input style={{ maxWidth: 100 }}
                          ref={minimunCallDurations}
                          className='mt-1 input-data'
                          disabled={!hold}
                          type="number"
                        />
                      </div>
                    </div>
                    <InputNesting
                      ref={maximunCallDurations} id="name"
                      type="number"
                      disabled={!hold}
                      containerClass="mr-2"
                      title={t('menu.genai.maximunCallDurationsVoice')}
                    />
                  </div>
                }
                {channel === 'chat' &&
                  <div className="inputs" style={{ marginTop: 10 }}>
                    <div className="input">
                      <div className='d-flex flex-row align-items-center'>
                        <div className='d-flex flex-row align-items-center'>
                          <span>{t('menu.genai.maximunCallDurations')}:</span>
                          <img id="max-user-response-tp" src="/icons/tooltip-indicator-icon.svg" className="ml-1 cursor-pointer tooltip-nesting" alt="" />
                          <Tooltip openOnClick={true} anchorSelect="#max-user-response-tp" 
                            html={t('menu.genai.maximunCallDurationsTooltip')} place="top" />
                        </div>
                        
                        <input style={{ maxWidth: 113 }}
                          ref={maxUserResponseTime}
                          className='mt-1 input-data'
                          disabled={!hold}
                          type="number"
                        />
                      </div>
                    </div>
                  </div>

                }

              </div>

              {channel === 'voice' &&
                <div className="inputs mt-3">
                  <div className="input">
                    <div className='d-flex flex-col  w-100 mr-3' style={{ alignItems: "center", flexDirection: "row" }}>
                      <div className='d-flex flex-row align-items-center' style={{marginRight: 10}}>
                        <span className='label-select'>{t('menu.genai.randomVoices')}:</span>
                        <img id="random-voices" src="/icons/tooltip-indicator-icon.svg" className="ml-2 cursor-pointer tooltip-nesting  " alt="" />
                        <Tooltip openOnClick={true} anchorSelect="#random-voices" 
                          html={t('menu.genai.randomVoicesTooltip')} place="top" />
                      </div>
                      <ButtonYesNo
                        onClick={() => setRadomVoice((prev) => !prev)}
                        width={150}
                        state={radomVoice}
                        height={30}
                      />
                    </div>
                  </div>
                </div>
              }

              {channel === 'voice' &&
                <div className="inputs mt-3">
                  <div className="input">
                    <div className="d-flex flex-row align-items-center justify-space-between w-100" >
                      <div className='d-flex flex-row align-items-center'>
                        <span>{t('menu.genai.selectVoice')}:</span>
                        <img id="select-voice" src="/icons/tooltip-indicator-icon.svg" className="ml-2 cursor-pointer tooltip-nesting  " alt="" />
                        <Tooltip openOnClick={true} anchorSelect="#select-voice" 
                          html={t('menu.genai.selectVoiceTooltip')} place="top" />
                      </div>
                      <select ref={voice_ref} className='select ml-2 select-nesting input-data ' style={{ flexGrow: '2', backgroundPositionX: "96%" }} 
                        id="voice">
                        <option disabled selected>{t('menu.genai.selectVoiceOption')}</option>
                        {voices.map((item, index) => (
                          <option key={index} value={item.id}>{item.voice}</option>
                        ))}
                      </select>
                    </div>
                  </div>
                </div>
              }

              {channel === 'chat' && <div className="inputs" style={{ marginTop: 20 }}>
                <div className="input">
                  <div className='d-flex flex-row align-items-center'>
                    <span>{t('menu.genai.replyTime')}:</span>
                    <img id="reply-time-tp" src="/icons/tooltip-indicator-icon.svg" className="ml-1 cursor-pointer tooltip-nesting" alt="" />
                    <Tooltip openOnClick={true} anchorSelect="#reply-time-tp" html={t('menu.genai.replyTimeTooltip')} place="top" />
                    <input style={{ maxWidth: 113 }}
                      ref={bot_respose_time_ref}
                      className='ml-3 input-data'
                      type="number"
                    />
                  </div>
                </div>
              </div>
              }

              {channel === 'chat' && (
              <div className="inputs" style={{ marginRight: 20, marginTop: 25 }}>
                <div className="input">
                  <div className="d-flex flex-row align-center">
                    <span>{t('menu.genai.customChat')}:</span>
                    <img id="custom-chat" src="/icons/tooltip-indicator-icon.svg" className="ml-2 cursor-pointer tooltip-nesting" alt="" />
                    <Tooltip openOnClick={true} anchorSelect="#custom-chat" 
                      html={t('menu.genai.customChatTooltip')} place="top" />
                    <div style={{ maxWidth: 200, minWidth: 100 }}>
                      <select
                        className='w-100 select-nesting input-data'
                        style={{ flexGrow: '2', backgroundPositionX: "96%" }}
                        id="custom_chat"
                        onChange={(e) => {
                          const value = e.target.value;
                          setSelectedChatOption(value === 'new' || value === '' ? '' : value);
                          setShowCustomChatForm(value === 'new');
                        }}
                      >
                        {customChats.map((item) => (
                          <option value={item.id} key={item.id}>{item.name}</option>
                        ))}
                        <option value="new">{t('common.new')}</option>
                      </select>
                    </div>
                  </div>
                </div>

                {showCustomChatForm && (
                  <CustomChat update={() => { fetchCustomChats() }} />
                )}
              </div>
              )}

            </div>

            

          </div>

          <div className="d-flex flex-row flex-wrap w-100" style={{margin: '40px 0 0 0', borderTop: '1px solid rgb(172 172 172)', padding: '15px 0 0 0'}}>
            <div className='d-flex flex-row mt-3 mb-3' style={{alignItems: 'center', width: '100%'}}>
              <h2 className="" style={{ color: '#1C6FB0', fontSize: 16, fontWeight: 'bold' }}>
                {t('menu.genai.simulationStatus')}:
              </h2>
              <div style={{marginLeft: 20}}>
                <ButtonYesNo
                  onClick={() => onChangeStatusSimulation()}
                  width={150}
                  state={simulationStatus === 0 ? false : simulationStatus}
                  height={30}
                  Yes={t('common.yes')}
                  No={t('common.no')}
                />
              </div>
            </div>
            
            <div className="inputs w-100 pr-2 mb-5 mt-2">
              <div className="input d-flex" style={{alignItems: 'center', flexDirection: 'row'}}>
                <span>{t('menu.genai.urlSimulation')}:</span>
                <input 
                  className='input-data' 
                  placeholder={t('menu.genai.urlSimulationPlaceholder')}
                  disabled={!simulationStatus}
                  ref={url_tp_simulation_ref}
                  type="text" 
                />
              </div>
            </div>

            
            
            <div className="inputs mt-1" style={{ marginRight: 30 }}>
              <div className="input d-flex items-center " style={{ height: "auto", flexDirection: 'row' }}>
                <span>{t('menu.genai.simulationStepNumber')}:</span>
                <img id="simulation-steps" src="/icons/tooltip-indicator-icon.svg" className="cursor-pointer tooltip-nesting" alt="" />
                <Tooltip openOnClick={true} anchorSelect="#simulation-steps" 
                  html={t('menu.genai.simulationStepNumberTooltip')} place="top" />
                <input 
                  disabled={!simulationStatus}
                  ref={Simulation_Step_number_ref} 
                  id="Simulation_Step_number_ref" 
                  style={{maxWidth: 90}}
                  type="text" 
                  className={`input-text input-data ${!simulationStatus ? 'disabled' : ''}`}
                />
              </div>
            </div>

            <div className="inputs mt-1" style={{ marginRight: 30 }}>
              <div className="input d-flex align-items-center" style={{ flexDirection: 'row' }}>
                <span>{t('menu.genai.assistedSimulation')}:</span>
                <img id="assisted-simulation" src="/icons/tooltip-indicator-icon.svg" className="cursor-pointer tooltip-nesting" alt="" />
                <Tooltip openOnClick={true} anchorSelect="#assisted-simulation" 
                  html={t('menu.genai.assistedSimulationTooltip')} place="top" />
                <div className="list_bot_type d-flex flex-row align-items-center">
                  <ButtonYesNo
                    onClick={() => setAssistedSimulation((prev) => prev === 0 ? 1 : 0)}
                    width={150}
                    state={assistedSimulation}
                    height={30}
                    Yes={t('common.yes')}
                    No={t('common.no')}
                    disabled={!simulationStatus}
                  />
                </div>
              </div>
            </div>

            <div className='d-flex flex-row flex-wrap mt-1 align-center'>
              {/*<div className="inputs" style={{ marginRight: 30 }}>
                <div className="input d-flex align-items-center" style={{flexDirection: 'row'}}>
                  <span>Azure Scenario:</span>
                  <img id="azure-scenario" src="/icons/tooltip-indicator-icon.svg" className="ml-1 cursor-pointer tooltip-nesting" alt="" />
                  <Tooltip openOnClick={true} anchorSelect="#azure-scenario" 
                    html={`Enable Azure scenario integration`} place="top" />
                  <div className="list_bot_type d-flex flex-row align-items-center">
                    <ButtonYesNo
                      onClick={() => setAzureScenario((prev) => prev === 0 ? 1 : 0)}
                      width={150}
                      state={azureScenario}
                      height={30}
                      Yes='Yes'
                      No='No'
                    />
                  </div>
                </div>
              </div>*/}
              
              <div className="inputs">
                <div className="input">
                  <div className='d-flex flex-col w-100 mr-3' style={{ alignItems: "center", flexDirection: "row" }}>
                    <span>{t('menu.genai.minimumPassingScore')}:</span>
                    <img id="min-score" src="/icons/tooltip-indicator-icon.svg" className="ml-1 cursor-pointer tooltip-nesting" alt="" />
                    <Tooltip openOnClick={true} anchorSelect="#min-score" 
                      html={t('menu.genai.minimumPassingScoreTooltip')} place="top" />
                    <input
                      ref={minimum_passing_score_ref}
                      defaultValue={70}
                      type="number"
                      min="1"
                      max="100"
                      className="input-text input-data ml-2"
                      style={{maxWidth: 90}}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div id="motor">
            {/*<div className="input">*/}
            {/*  <span>Motor:</span>*/}
            {/*  <div className="motor">*/}
            {/*    <input*/}
            {/*      {...register('motor', { required: true })}*/}
            {/*      type="radio"*/}
            {/*      id="motor_1"*/}
            {/*      value="1"*/}
            {/*    />*/}
            {/*    <label htmlFor="motor_1">*/}
            {/*      <span>Motor 1</span>*/}
            {/*    </label>*/}
            {/*    <input {...register('motor')} type="radio" id="motor_2" value="2" />*/}
            {/*    <label htmlFor="motor_2">*/}
            {/*      <span>Motor 2</span>*/}
            {/*    </label>*/}
            {/*  </div>*/}
            {/*</div>*/}
          </div>

          {/*<div className="inputs" id="metadata">*/}
          {/*  <div className="flex items-center justify-end">*/}
          {/*    <div className="upload-excel trans">*/}
          {/*      <img src="/icons/excel.svg" alt="newAns" /><label> {t('menu.uploadExcel')}</label>*/}
          {/*      <input type='file' accept='.xlsx, .xls' onChange={prepareExcel} />*/}
          {/*    </div>*/}
          {/*    <div className="input">*/}
          {/*      <a className="a-download trans" href={"/excel/FormatProjects.xlsx"} download >Download Template</a>*/}
          {/*    </div>*/}
          {/*    <div className="input">*/}
          {/*      <div onClick={() => { uploadMaxive() }} className="a-download upload-btn trans"   >*/}
          {/*        <div className='btn-loanding'>*/}
          {/*          {loadingUpload ? <Loading /> : <div>Upload Projects</div>}*/}
          {/*        </div>*/}

          {/*      </div>*/}
          {/*    </div>*/}
          {/*  </div>*/}
          {/*</div>*/}
          <div className="footer" style={{ marginTop: 30 }}>
            <div className='cont-buttons'>
              {/* {errors.name?.type === 'required' ||
                errors.motor?.type === 'required' ||
                errors.metadata?.type === 'required' ? (
                <span style={{ color: "red" }}>{t('menu.fieldsRequired')}</span>
              ) : (
                <span> </span>
              )} */}
              <span className='errors-msg'  >{error.name}</span>
            </div>

          </div>
        </div>
        <div className='cont-buttons' style={{
          paddingRight: 20,
          width: '100%',
          justifyContent: 'flex-end',
          alignItems: 'flex-end',
          paddingTop: 12
        }}>
          <div className="buttons flex items-center" style={{ marginBottom: 20, }}>
            <button className="cancel btn-bottom btn-bottom-cancel" type="button" style={{ marginRight: 10, color: 'white' }} onClick={() => onClose()}>
              {t('common.cancel')}
            </button>
            <button className="create btn-bottom btn-bottom-create" type="button" style={{ color: 'white' }} onClick={() => createProject()}>
              {t('common.create')}
            </button>
          </div>

        </div>
      </form>
      {alert.visible && <Alerts id="alert-ac" title={alert.title} error={alert.error} />}
    </div>

  )
}
